import Vue from "vue";
import VueI18n from "vue-i18n";

import en from "./en.json";
import hu from "./hu.json";

Vue.use(VueI18n);

const locale = "hu";

const messages = {
	en: en,
	hu: hu
};

const i18n = new VueI18n({
	silentTranslationWarn: true,
	locale,
	messages
});

export default i18n;
